import { Typography } from "@mui/material";
import { ProductMetaWrapper } from "../styles/product";

export default function ProductPrice({ price, matches }) {
  return (
    <ProductMetaWrapper>
      <Typography
        variant={matches ? "caption" : "subtitle2"}
        sx={{
          fontSize: matches ? "1.2rem" : "1.4rem",
          fontWeight: 700,
          color: "#D81B60",
          textAlign: "center",
        }}
      >
        ₪{Number(price) || 0}
      </Typography>
    </ProductMetaWrapper>
  );
}
